import * as z from "zod";
import { AeoPromptSchema } from "./schemas/aeo-prompt";

export const getAeoPrompts = {
  name: "getAeoPrompts" as const,
  input: z.object({
    status: z.enum(["active", "archived"]).default("active"),
    branded: z.boolean().optional(),
    search: z.string().optional(),
    limit: z.number().optional(),
    offset: z.number().optional(),
    sortKey: z.enum(["prompt", "createdAt", "branded"]).optional(),
    sortDirection: z.enum(["asc", "desc"]).optional(),
    topicIds: z.array(z.bigint()).optional(),
  }),
  output: z.object({
    prompts: z.array(AeoPromptSchema),
    totalCount: z.number(),
  }),
};
